import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #f3f4f8;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ChoiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
`;

export const FooterContainer = styled.div`
  display: flex;
  align-self: self-end;
  margin-right: 2%;
  margin-top: 3%;
  margin-bottom: 3%;
`;

export const Text = styled.p`
  font-size: 24px;
  font-weight: bold;
  margin-left: 2%;
  margin-top: 2%;
`;

export const TextChoice = styled.p`
  font-size: 16px;
  margin-left: 2%;
  width: 100%;
  margin-top: 2%;
`;

export const InputIcon = styled.img`
  height: auto;
  width: 24px;
`;

export const EmailIcon = styled(InputIcon)`
  position: absolute;
  width: 18px;
  left: 16px;
`;

export const QuestionIcon = styled(InputIcon)`
  width: 22px;
  cursor: pointer;
`;

export const CloseIcon = styled(QuestionIcon)`
  width: 20px;
  align-self: flex-end;
  margin-bottom: 4%;
  margin-right: 2.5%;
`;
